import { useState } from 'react';

interface OnboardingModalProps {
  onComplete: () => void;
}

const slides = [
  {
    emoji: '🌿',
    title: 'Добро пожаловать в Stoneflower!',
    description: 'Ваш персональный помощник по уходу за комнатными растениями.',
  },
  {
    emoji: '💧',
    title: 'Умные напоминания',
    description: 'Мы рассчитаем график полива и подкормки с учётом сезона, горшка и вида растения.',
  },
  {
    emoji: '💬',
    title: 'Растения общаются!',
    description: 'Каждое растение имеет характер и будет писать вам сообщения — благодарить, напоминать, шутить.',
  },
  {
    emoji: '🏆',
    title: 'Стрики и достижения',
    description: 'Ухаживайте за растениями каждый день, открывайте достижения и стройте серии!',
  },
];

export default function OnboardingModal({ onComplete }: OnboardingModalProps) {
  const [current, setCurrent] = useState(0);

  const handleNext = () => {
    if (current < slides.length - 1) {
      setCurrent(current + 1);
    } else {
      onComplete();
    }
  };

  const slide = slides[current];

  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center px-6"
      style={{
        background: 'var(--tg-theme-bg-color, #ffffff)',
      }}
    >
      <div className="flex-1 flex flex-col items-center justify-center max-w-sm">
        <div className="w-28 h-28 rounded-full glass-circle-green flex items-center justify-center mb-8 animate-float">
          <span className="text-6xl">{slide.emoji}</span>
        </div>

        <h2 className="text-2xl font-bold text-center mb-3">{slide.title}</h2>
        <p className="text-center text-tg-hint leading-relaxed">{slide.description}</p>
      </div>

      <div className="w-full max-w-sm pb-10 space-y-4">
        {/* Dots */}
        <div className="flex justify-center gap-2">
          {slides.map((_, i) => (
            <div
              key={i}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === current ? 'w-6 bg-plant-green-500' : 'w-2 glass-circle'
              }`}
            />
          ))}
        </div>

        {/* Buttons */}
        <button
          onClick={handleNext}
          className="tg-button w-full"
        >
          {current < slides.length - 1 ? 'Далее' : 'Начать!'}
        </button>

        {current < slides.length - 1 && (
          <button
            onClick={onComplete}
            className="w-full py-2 text-sm text-tg-hint font-medium"
          >
            Пропустить
          </button>
        )}
      </div>
    </div>
  );
}
